export const environment = {
  production: false,
  apiUrl: 'https://api-ventaclick-dev.megatecs.org',
  apiEvolutionUrl: 'https://api-mica-chat-evo-dev.megatecs.org',
  apiMicaChatUrl: 'https://api-mica-chat-dev.megatecs.org',
  apiPreFix: '/api',
  superAdminOtpEnabled: false,
};
